export class StoreTrialDates {
  constructor(
    readonly expectedStartDate: Date,
    readonly expectedEndDate: Date,
    readonly startDate: Date,
    readonly endDate: Date) {
  }
}